import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import GmapVue, { components } from 'gmap-vue'
import '@mdi/font/css/materialdesignicons.css'
import GmapVue from 'gmap-vue'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import CountryFlag from 'vue-country-flag'
import { getDefaultValue } from './utilities'

Vue.config.productionTip = false

// Vue.component('gmap-cluster', components.Cluster)
Vue.component('country-flag', CountryFlag)

Vue.use(GmapVue, {
  load: {
    // key: process.env.NODE_ENV === 'production' ? 'AIzaSyChqPhP8whqcJTyUVU1bULDW67DRDIjWFc' : 'AIzaSyBjMBDEKPU-DE7ZGQA8sYcD10Trmbh6zEI',
    // key: process.env.NODE_ENV === 'production' ? 'AIzaSyAFxa2Ks6PKYzwePO0l5Si8Z0BNir9u1DM' : 'AIzaSyBjMBDEKPU-DE7ZGQA8sYcD10Trmbh6zEI',
    key:
      process.env.NODE_ENV === 'production'
        ? 'AIzaSyCLWYbB9YperZ9nH5Ad_jiQFoc7ZNGGcYw'
        : 'AIzaSyBjMBDEKPU-DE7ZGQA8sYcD10Trmbh6zEI',
    libraries: 'geometry,visualization',
    region: getDefaultValue('language').countryCode,
    language: getDefaultValue('language').languageCode,
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
